import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Download, X } from "lucide-react";
import { onInstallPrompt, promptInstall } from "@/lib/pwa";

export default function InstallApp() {
  const [visible, setVisible] = useState(false);

  useEffect(() => onInstallPrompt(() => setVisible(true)), []);

  const install = async () => {
    await promptInstall();
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="install-app-prompt"
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-24 right-4 z-50 max-w-xs border border-primary/40 bg-black/90 p-5 backdrop-blur-xl md:right-6"
        >
          <button
            data-testid="install-app-dismiss"
            onClick={() => setVisible(false)}
            aria-label="Dismiss install prompt"
            className="absolute right-2 top-2 p-1 text-white/40 transition-colors duration-300 hover:text-white"
          >
            <X size={14} />
          </button>
          <p className="font-mono text-[10px] tracking-[0.3em] text-primary">TAKE MILLZZ ON THE GO</p>
          <p className="mt-2 text-sm text-white/70">
            Install the app on your phone — music, merch and tour dates one tap away.
          </p>
          <button
            data-testid="install-app-button"
            onClick={install}
            className="mt-4 flex w-full items-center justify-center gap-2 bg-primary px-4 py-3 font-mono text-xs font-bold tracking-[0.2em] text-black transition-transform duration-300 hover:-translate-y-0.5"
          >
            <Download size={14} /> INSTALL APP
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
